
import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../styles/AboutUs.css';
import alexPortrait from '../assets/alex-headshot.png';
import annaPortrait from '../assets/annie-headshot.png';
import salesRep from '../assets/christopher-headshot.png';
import krisPortrait from '../assets/kristopher-headshot.png';
import Footer from '../components/Footer';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const AboutUs = () => {

  const lenisRef = useRef(null);

  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    

  /* ------------------------------------------------------------------ */

  // Team data array for easier management and mapping
  const teamMembers = [
    {
      name: 'Alex Mitchell',
      role: 'Co-owner',
      img: alexPortrait,
      bio: 'Alex oversees day-to-day logistics, ensuring every transformer and breaker is processed safely and efficiently. He cut his teeth repairing appliances at the family’s Al & Annie’s Appliances storefront in Decatur, Alabama, before scaling that knack for detail to industrial equipment.'
    },
      {
      name: 'Christopher John',
      role: 'Co-Owner',
      img: salesRep,
      bio: 'Christopher bridges the gap between surplus sellers and our technical team, translating complex equipment specs into clear, fair offers. With a background in industrial distribution and a knack for relationship-building, he ensures every vendor walks away confident in the value of their deal.'
    },
    {
      name: 'Anna Weir',
      role: 'Chief Strategy Officer',
      img: annaPortrait,
      bio: 'Anna manages vendor relations and keeps S&D’s offers competitive without compromising the bottom line. Her background running the books—and the showroom—at Al & Annie’s Appliances makes her the perfect liaison between buyers, sellers, and recycling partners.'
    },
    {
      name: 'Kristopher Ilich',
      role: 'Director of Software Development',
      img: krisPortrait,
      bio: 'Kristopher leads our software development initiatives, driving the creation of robust digital tools to streamline surplus equipment transactions. With experience in full-stack development and system architecture, he ensures our platforms are secure, scalable, and user-friendly, enhancing efficiency for both buyers and sellers in the industrial sector.'
    }
  ];

  const [selectedMember, setSelectedMember] = useState(null);

  useEffect(() => {
    if (selectedMember) {
      lenisRef.current?.stop();
      document.body.style.overflow = 'hidden';
    } else {
      lenisRef.current?.start();
      document.body.style.overflow = '';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = '';
    };
  }, [selectedMember]);

  return (
    <div className="lenis-content">
      {/* ---------- HERO BANNER ---------- */}
      <section className="about-hero">
        <div className="about-hero__overlay">
          <h1 className="about-hero__title">
            Our mission is to maximize <span>value </span>
            through responsible reuse of industrial assets
          </h1>
        </div>
      </section>

      <main>
        {/* ---------- OUR STORY ---------- */}
        <section className="about-story container">
          <h2 className="section-heading">Our story</h2>

          <p>
            Founded in 2010, <strong>S&D Industrial Surplus</strong> grew from a
            modest scrapyard operation into one of the largest buyers of
            transformers, switchgear, and PVF equipment in North America.
            We realised early that industry needed a transparent partner—one
            who could extract maximum value from surplus assets while keeping
            sustainability front-and-centre.
          </p>
          <br/>
          <p>
            Today we purchase, refurbish, and responsibly redistribute surplus
            machinery across the globe. Our customers know exactly what their
            equipment is worth, and our vendors trust that nothing goes to
            waste. It’s a win-win that keeps critical materials in circulation
            and delivers better returns for everyone in the supply chain.
          </p>
        </section>

        {/* ---------- TEAM ---------- */}
        <section className="about-team">
          <h2 className="section-heading section-heading--light">Our team</h2>

          <div className="team-grid container">
            {teamMembers.map((member, index) => (
              <article 
                key={index} 
                className="team-card" 
                onClick={() => setSelectedMember(member)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter') setSelectedMember(member); }}
              >
                <div className="team-card__img placeholder-img">
                  <img src={member.img} alt={`${member.name}'s Headshot`} />
                </div>
                <div className='card-text-wrapper'>
                  <h3 className="team-card__name">{member.name}</h3>
                  <p className="team-card__role">{member.role}</p>
                   <span className="arrow">→</span>
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>

      {/* Global footer */}
      <Footer />

      {/* Modal for expanded team member info */}
      {selectedMember && createPortal(
        <div className="modal-backdrop open" onClick={() => setSelectedMember(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedMember(null)}>×</button>
            <div className="modal-content">
              <img src={selectedMember.img} alt={`${selectedMember.name}'s Headshot`} className="modal-img" />
              <div className="modal-text">
                <h3 className="modal-name">{selectedMember.name}</h3>
                <p className="modal-role">{selectedMember.role}</p>
                <p className="modal-bio">{selectedMember.bio}</p>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default AboutUs;

